import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';
import { Controller } from 'react-hook-form';

import { useTranslation } from '@gem/modules/i18n';
import { Button, ButtonTypes, TextField } from '@gem/ui-kit';

import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { LoginSupportInfo } from '../../../components/LoginSupportInfo/LoginSupportInfo';
import { ILoginViewProps } from '../../Login.types';
import { LoginOptions } from '../../LoginOptions/LoginOptions';
import { useLoginEmailStepPresenter } from './LoginEmailStep.presenter';
import styles from './LoginEmailStep.styles.m.css';

export const LoginEmailStep: FC<ILoginViewProps> = observer((props) => {
  const { t } = useTranslation();
  const { loginPresenter } = props;
  const { presenter, form } = useLoginEmailStepPresenter(props);

  return (
    <UnauthorizedLayoutTemplate
      onBack={loginPresenter.onBackHandler || undefined}
      title={t('auth_sign_in')}
      subtitle={t('auth_signin_subtitle_newflow')}
      info={<LoginSupportInfo />}
      message={loginPresenter.errorMessage}
    >
      <div className={styles.content}>
        <form
          className={styles.form}
          onSubmit={presenter.onSubmit}
        >
          <Controller
            control={form.control}
            name="email"
            render={({ field, fieldState }): ReactElement => (
              <TextField
                autoComplete="email"
                className={styles.formControl}
                {...field}
                isDisabled={form.formState.isSubmitting || field.disabled}
                ref={null}
                label={t('auth_email')}
                hasError={fieldState.invalid}
                message={fieldState.error?.message || ' '}
              />
            )}
          />
          <Button
            className={styles.submit}
            type={ButtonTypes.Submit}
            theme="primary"
            size="20"
            isLoading={form.formState.isSubmitting}
            isDisabled={!form.formState.isValid || !presenter.isFilled}
          >
            {t('auth_continue')}
          </Button>
        </form>
        {loginPresenter.isShowOtherOptions && <LoginOptions className={styles.options} />}
      </div>
    </UnauthorizedLayoutTemplate>
  );
});
